import React from 'react';

import {
  ELocationSearchAutocompleteListVariant,
  LocationSearchAutocompleteList,
} from '@/components/common/LocationSearchAutocompleteList';
import { ESearchDropdownAlignment } from '@/hooks/useSearchDropdownAlignment';
import { calculateOptionIndex } from '@/utility/autoCompleteGroupedOptions';

import { DesktopFilterContent } from './DesktopFilterContent';
import { useLocationAutocompleteContext } from './LocationAutocompleteContext';

type LocationAutocompleteMenuProps = {
  align: ESearchDropdownAlignment;
  searchBarRef?: React.RefObject<HTMLDivElement>;
  buttonRef?: React.RefObject<HTMLDivElement>;
};

export const LocationAutocompleteMenu = ({
  align,
  buttonRef,
  searchBarRef,
}: LocationAutocompleteMenuProps) => {
  const { isOpened, menuProps, allGroupedOptions, groupedOptions, getOptionProps } =
    useLocationAutocompleteContext();

  return (
    <DesktopFilterContent
      isOpened={isOpened}
      content={
        <div {...menuProps}>
          <LocationSearchAutocompleteList
            groupedOptions={groupedOptions}
            getOptionProps={({ option, index }) =>
              getOptionProps({
                option,
                index: calculateOptionIndex(option.groupName, index, allGroupedOptions),
              })
            }
            variant={ELocationSearchAutocompleteListVariant.Horizontal}
          />
        </div>
      }
      align={align}
      searchBarRef={searchBarRef}
      buttonRef={buttonRef}
      useSearchBarWidth={true}
    />
  );
};
